import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { fetchAllLeasesByAdmin ,deleteLease} from '../actions/LeaseActions';

const initialState = {
  leases: [],
  loading: false,
  error: null,
  pagination: null
};

const leaseSlice = createSlice({
  name: 'lease',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllLeasesByAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllLeasesByAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.leases = action.payload.data || [];
        state.pagination = action.payload.meta || null;
      })
      .addCase(fetchAllLeasesByAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || 'Failed to fetch leases';
      })
      .addCase(deleteLease.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteLease.fulfilled, (state, action) => {
        state.loading = false;
        toast.success('Lease deleted successfully');
        // ✅ remove lease from state immediately
        state.leases = state.leases.filter(
          (lease) => lease.id !== action.payload.leaseId
        );
      })
      .addCase(deleteLease.rejected, (state, action) => {
        state.loading = false;
        const message = action.payload?.message || 'Failed to delete lease';
        state.error = message;
        toast.error(message);
      });
      
  }
});

export default leaseSlice.reducer;
